import Rating from "@/components/airport/rental-company-list/Rating";
import parse from "html-react-parser";
// import Link from 'next/link'

import React, { useEffect, useState } from "react";

const OtherRentalCompanies = ({
  baseUrl,
  agencyList,
  locationName,
  locale,
  data,
  currentAgency,
  title,
}: {
  baseUrl: string;
  agencyList: Agency[];
  locationName: string;
  locale: string;
  currentAgency: string;
  data?: any;
  title?: string;
}) => {
  const [isUserAgentBot, setIsUserAgentBot] = useState(true);
  useEffect(() => {
    if (!/bot/i.test(navigator.userAgent)) setIsUserAgentBot(false);
  }, []);
  const dynamicContent = `If you still haven't found a rental car deal from ${currentAgency} that you think would suit you, you should check rental car deals from the following companies to see if they have something for you. All these companies offer their service at ${locationName}. Do check them out to see what they have to offer.`;

  return (
    <section
      id="rental-company-list"
      className="py-[30px] lg:py-[60px] bg-white mt-[22px] lg:mt-[40px]"
    >
      <div className="max-w-7xl mx-auto px-[13px]">
        <h2 className="font-extrabold text-lg lg:text-3xl text-my-dark-blue mb-[22px] lg:mb-[40px]">
          {title
            ? title
            : `Other car rental companies in ${locationName} similar to ${currentAgency}`}
        </h2>
        <div className="space-y-6 text-sm font-normal text-my-light-blue lg:font-light lg:text-base">
          {dynamicContent}
        </div>
        <div className="lg:border-shadow lg:py-[30px] lg:px-[22px] rounded-[22px]">
          {isUserAgentBot && (
            <table>
              <tr>
                <th>Rental Agency Name</th>
                <th>Rating</th>
                <th>Agency Image</th>
                <th>Page Link</th>
              </tr>
              {agencyList
                .sort((a, b) => {
                  if (a.pickupLocation?.overallScore?.score === undefined)
                    return 1;
                  if (b.pickupLocation?.overallScore?.score === undefined)
                    return -1;
                  return (
                    b.pickupLocation?.overallScore?.score -
                    a.pickupLocation?.overallScore?.score
                  );
                })
                .slice(0, 10)
                .map((data, _) => {
                  return (
                    <tr key={_}>
                      <td>{`${data.name} ${
                        data.name.split(" ").length === 1 ? `Car Rentals` : ""
                      }`}</td>
                      <td>
                        {`${
                          data.pickupLocation.overallScore
                            ? data.pickupLocation.overallScore.score
                            : 7
                        }/10`}
                      </td>
                      <td>
                        <img
                          loading="lazy"
                          src={`https://content.r9cdn.net/rimg/provider-logos/cars/h/${data.icon}`}
                          width={100}
                          height={50}
                          alt={data.name}
                        />
                      </td>
                      <td>
                        <a
                          className="text-sm font-medium lg:text-xl text-[#004DE3] hover:opacity-80 transition"
                          href={`/${baseUrl}/agency/${data.providerCode
                            .toLowerCase()
                            .replace(/_/g, "-")}`}
                        >
                          {`${data.name} ${
                            data.name.split(" ").length === 1
                              ? `Car Rentals`
                              : ""
                          }`}
                        </a>
                      </td>
                    </tr>
                  );
                })}
            </table>
          )}
          {!isUserAgentBot && (
            <div className="flex flex-col lg:grid lg:grid-cols-2 items-start justify-start lg:gap-x-[80px]">
              {agencyList
                .sort((a, b) => {
                  if (a.pickupLocation?.overallScore?.score === undefined)
                    return 1;
                  if (b.pickupLocation?.overallScore?.score === undefined)
                    return -1;
                  return (
                    b.pickupLocation?.overallScore?.score -
                    a.pickupLocation?.overallScore?.score
                  );
                })
                .slice(0, 10)
                .map((data) => {
                  return (
                    <div
                      key={data.providerCode}
                      className={`w-full flex items-center justify-between py-6`}
                    >
                      <div className="flex items-center justify-center gap-3">
                        <div className="w-[70px] h-[35px] lg:w-[100px] lg:h-[50px]">
                          <img
                            loading="lazy"
                            src={`https://content.r9cdn.net/rimg/provider-logos/cars/h/${data.icon}`}
                            width={100}
                            height={50}
                            alt={data.name}
                          />
                        </div>
                        <div className="flex flex-col items-start justiy-center gap-[3px]">
                          <a
                            className="text-sm font-medium lg:text-xl text-[#004DE3] hover:opacity-80 transition"
                            href={`/${baseUrl}/agency/${data.providerCode
                              .toLowerCase()
                              .replace(/_/g, "-")}`}
                          >
                            {`${data.name} ${
                              data.name.split(" ").length === 1
                                ? `Car Rentals`
                                : ""
                            }`}
                          </a>
                          <div className="flex items-center justify-center gap-[6px]">
                            <Rating
                              rating={
                                data.pickupLocation.overallScore
                                  ? data.pickupLocation.overallScore.score
                                  : 7
                              }
                            />

                            <p className="font-medium text-[10px] lg:text-base text-[#004DE3] bg-[#004DE314] px-[6px] py-[4px] leading-[20px] lg:px-[10px] lg:py-[6px] w-fit rounded-full">
                              {data.pickupLocation.overallScore
                                ? data.pickupLocation.overallScore.score
                                : 7}
                              /10
                            </p>
                          </div>
                        </div>
                      </div>

                      <a
                        href={`/${baseUrl}/agency/${data.providerCode
                          .toLowerCase()
                          .replace(/_/g, "-")}`}
                        className="flex justify-between items-center cursor-pointer border-[0.7px] border-[#004DE3] bg-[#004DE30D] rounded-full font-semibold text-[11px] lg:text-lg text-[#004DE3] px-[6px] py-[11px] lg:px-[14px] lg:py-4 lg:leading-[22px] hover:bg-[#004DE3] hover:text-white transition leading-[13px]"
                      >
                        <p>Check price</p>

                        <div className="relative w-[20px] h-[20px] lg:w-[24px] lg:h-[24px]">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.70078 18.3L8.30078 16.9L12.9008 12.3L8.30078 7.70005L9.70078 6.30005L15.7008 12.3L9.70078 18.3Z"
                              fill="#004DE3"
                              className="fill-current"
                            />
                          </svg>
                        </div>
                      </a>
                    </div>
                  );
                })}
              {/* <button className='block lg:hidden border-t-[0.5px] border-[#D8DFEE] w-full pt-[18px] font-medium text-sm'>
							See more
						</button> */}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default OtherRentalCompanies;
